module.exports = __webpack_public_path__ + "img/2g-IAwszlz0R5K7eHIFTZY.7c7fa7ec.svg";